module.exports = __webpack_public_path__ + "prod/1.2.3/img/tip.8da3c63e.png";